import { colors } from '@configs/styles/config'
import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  children?: ReactNode
  color?: string
  width?: string
  height?: string
  rotate?: string
}

const InfinityIcon: React.FunctionComponent<Props> = (props) => {
  const { width, height } = props
  return (
    <svg
      width={width ? width : '100%'}
      height={height ? height : '100%'}
      viewBox="0 0 25 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>infinity</title>
      <defs>
        <filter
          x="-11.1%"
          y="-6.0%"
          width="122.2%"
          height="112.1%"
          filterUnits="objectBoundingBox"
          id="filter-1"
        >
          <feGaussianBlur stdDeviation="19" in="SourceGraphic"></feGaussianBlur>
        </filter>
      </defs>
      <g id="УГУ" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="courses" transform="translate(-1291.000000, -954.000000)">
          <rect
            id="Rectangle"
            fill="#000000"
            opacity="0.045921689"
            filter="url(#filter-1)"
            x="1176"
            y="237"
            width="514"
            height="944"
            rx="1"
          ></rect>
          <rect
            id="Rectangle-Copy-4"
            fill="#FFFFFF"
            x="1215"
            y="183"
            width="520"
            height="973"
            rx="15"
          ></rect>
          <g
            id="infinity"
            transform="translate(1291.000000, 954.000000)"
            fill={colors?.uguBrightPurple}
            fillRule="nonzero"
          >
            <path
              d="M19.2856237,0 C15.7388729,0 13.3916801,2.86595395 11.3209116,5.39506579 C9.55169669,7.55559211 7.88100267,9.59572368 5.8461809,9.59572368 C3.73114452,9.59572368 2.43256643,7.44736842 2.43256643,5.90723684 C2.43256643,4.47927632 3.85712473,2.40411184 6.08982031,2.40411184 C8.25628059,2.40411184 9.38494348,4.11776316 9.44185925,4.20559211 C9.79283979,4.76694079 10.5380702,4.94358553 11.108892,4.59950658 C11.682543,4.25411184 11.864274,3.51447368 11.5146249,2.94753289 C11.4404014,2.82746711 9.65620867,0.000164473684 6.08982031,0.000164473684 C2.50113162,0.000164473684 0,3.11365132 0,5.90740132 C0,8.78914474 2.40094656,12 5.84601448,12 C9.04111901,12 11.1614808,9.41118421 13.2116133,6.90740132 C15.1081397,4.59194079 16.8996549,2.40427632 19.2856237,2.40427632 C20.7051894,2.40427632 21.6379755,2.88026316 22.1365709,3.85822368 C22.5685982,4.70690789 22.5682653,5.66726974 22.5679325,6 C22.5679325,6.19078947 22.4659168,7.14769737 21.9936158,8.009375 C21.4550795,8.99095395 20.6905444,9.44786184 19.5856796,9.44786184 C17.3608058,9.44786184 16.1587515,8.01858553 15.7060881,7.48026316 C15.5884289,7.34013158 15.5037209,7.23930921 15.3905551,7.14358553 C14.8809759,6.71217105 14.1127796,6.77006579 13.6754268,7.27434211 C13.2537176,7.76069079 13.2943242,8.48371711 13.7549758,8.92138158 C13.7769433,8.94605263 13.8034041,8.97845395 13.8348575,9.01611842 C14.4248177,9.71776316 16.2186628,11.8516447 19.5851803,11.8516447 C23.6767913,11.8516447 25,7.90871711 25,5.98355263 C25.0003325,4.75740132 24.7680097,3.67878289 24.3086895,2.77697368 C23.6638106,1.51052632 22.2685422,0 19.2856237,0 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default InfinityIcon
